import { Link } from "react-router-dom";

export function Footer() {
    return (
        <footer className="bg-gray-700 text-white h-16 flex items-center justify-between px-4 w-full z-10">
            <p className="text-sm">&copy; 2025 SendFalcon. All rights reserved.</p>
            <nav className="flex space-x-4">
                <Link to="About" className="hover:text-indigo-300 transition-colors">About</Link>
                <Link to="Terms" className="hover:text-indigo-300 transition-colors">Terms Of Use</Link>
                <Link to="Privacy" className="hover:text-indigo-300 transition-colors">Privacy Policy</Link>
                <Link to="Contact" className="hover:text-indigo-300 transition-colors">Contact</Link>
            </nav>
        </footer>
    );
}